import { IRendererConfig, ICol, EditorType, IEditor, GridEvents } from "../../types";
import { InputEditor } from "./InputEditor";
import { SelectEditor } from "./SelectEditor";
import { DateEditor } from "./DateEditor";
import { CheckboxEditor } from "./CheckboxEditor";
import { ComboboxEditor } from "./ComboboxEditor";

let lastEditor = {
	cell: {
		row: null,
		col: null
	},
	editor: null
};

let editHandler;

export function getEditor(row: any, col: ICol, conf: IRendererConfig): IEditor {
	const type = col.type === "boolean" ? EditorType.checkbox : conf.$editable.editorType;
	if (lastEditor.cell.row === row.id && lastEditor.cell.col === col.id) {
		return lastEditor.editor;
	}

	lastEditor.cell = {
		row: row.id,
		col: col.id
	};

	if (!editHandler) {
		editHandler = () => {
			lastEditor = {
				cell: {
					row: null,
					col: null
				},
				editor: null
			};
		};
		conf.events.on(GridEvents.afterEditEnd, editHandler);
	}

	switch (type) {
		case EditorType.input:
			return lastEditor.editor = new InputEditor(row, col, conf);
		case EditorType.select:
			return lastEditor.editor = new SelectEditor(row, col, conf);
		case EditorType.datepicker:
			return lastEditor.editor = new DateEditor(row, col, conf);
		case EditorType.checkbox:
			return lastEditor.editor = new CheckboxEditor(row, col, conf);
		case EditorType.combobox:
			return lastEditor.editor = new ComboboxEditor(row, col, conf);
		default:
			return lastEditor.editor = new InputEditor(row, col, conf);
	}
}
